import { useCallback } from 'react'

import { Button, Layout, Link, Text } from '@loadsmart/loadsmart-ui'

import TrackingIcon from 'legacy/assets/svg/tracking.svg'
import analytics from 'legacy/utils/analytics'

import { ContentWrapper, ImageWrapper, Wrapper } from './Step.styles'
import { type StepProps } from './Step.types'
import { ResponsiveLayoutStack } from './TrackingIntegrationStep.styles'

export const P44_URL = 'https://na12.voc.project44.com/portal/v2/public/connect/loadsmart'

export function TrackingIntegrationStep({ loadOffer, onComplete }: StepProps) {
  const handleProject44 = useCallback(() => {
    analytics.track('Load Setup / Tracking Integration', {
      service: 'P44',
    })
    window.open(P44_URL, '_blank', 'noopener')?.focus()
    onComplete()
  }, [onComplete])

  const handleAlreadyConnected = useCallback(() => {
    analytics.track('Load Setup / Tracking Integration / Completed')
    onComplete()
  }, [onComplete])

  return (
    <Wrapper>
      <ImageWrapper>
        <img src={TrackingIcon} alt="Allow Tracking" />
      </ImageWrapper>
      <ContentWrapper>
        <Layout.Stack space="s">
          <Layout.Group>
            <Text as="p" variant="heading-sm">
              Choose one tracking service to integrate and don't worry with tracking on the pickup
              day.
            </Text>
          </Layout.Group>
          <Layout.Group>
            <Text as="p" variant="heading-sm">
              <span>{`What is `}</span>
              <Link href="https://project44.com" target="_blank">
                Project-44
              </Link>
            </Text>
          </Layout.Group>
          <ResponsiveLayoutStack space="s">
            <Layout.Group>
              <Button variant="primary" onClick={handleProject44}>
                Track with project 44
              </Button>
            </Layout.Group>
            <Layout.Group>
              <Button variant="tertiary" onClick={handleAlreadyConnected}>
                I'm already connected
              </Button>
            </Layout.Group>
          </ResponsiveLayoutStack>
        </Layout.Stack>
      </ContentWrapper>
    </Wrapper>
  )
}
